/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RedeemRequest model module.
 * @module model/RedeemRequest
 * @version v1
 */
class RedeemRequest {
    /**
     * Constructs a new <code>RedeemRequest</code>.
     * @alias module:model/RedeemRequest
     * @param giftCardNum {String} MaxLength:25
     * @param giftCardSecurityCode {String} MaxLength:3
     * @param amount {Number} 
     * @param orderId {Number} int64
     * @param transactionRef {String} MaxLength:35
     */
    constructor(giftCardNum, giftCardSecurityCode, amount, orderId, transactionRef) { 
        
        RedeemRequest.initialize(this, giftCardNum, giftCardSecurityCode, amount, orderId, transactionRef);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, giftCardNum, giftCardSecurityCode, amount, orderId, transactionRef) { 
        obj['GiftCardNum'] = giftCardNum;
        obj['GiftCardSecurityCode'] = giftCardSecurityCode;
        obj['Amount'] = amount;
        obj['OrderId'] = orderId;
        obj['TransactionRef'] = transactionRef;
    }

    /**
     * Constructs a <code>RedeemRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RedeemRequest} obj Optional instance to populate.
     * @return {module:model/RedeemRequest} The populated <code>RedeemRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RedeemRequest();

            if (data.hasOwnProperty('GiftCardNum')) {
                obj['GiftCardNum'] = ApiClient.convertToType(data['GiftCardNum'], 'String');
            }
            if (data.hasOwnProperty('GiftCardSecurityCode')) {
                obj['GiftCardSecurityCode'] = ApiClient.convertToType(data['GiftCardSecurityCode'], 'String');
            }
            if (data.hasOwnProperty('Amount')) {
                obj['Amount'] = ApiClient.convertToType(data['Amount'], 'Number');
            }
            if (data.hasOwnProperty('OrderId')) {
                obj['OrderId'] = ApiClient.convertToType(data['OrderId'], 'Number');
            }
            if (data.hasOwnProperty('TransactionRef')) {
                obj['TransactionRef'] = ApiClient.convertToType(data['TransactionRef'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>RedeemRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RedeemRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of RedeemRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['GiftCardNum'] && !(typeof data['GiftCardNum'] === 'string' || data['GiftCardNum'] instanceof String)) {
            throw new Error("Expected the field `GiftCardNum` to be a primitive type in the JSON string but got " + data['GiftCardNum']);
        }
        // ensure the json data is a string
        if (data['GiftCardSecurityCode'] && !(typeof data['GiftCardSecurityCode'] === 'string' || data['GiftCardSecurityCode'] instanceof String)) {
            throw new Error("Expected the field `GiftCardSecurityCode` to be a primitive type in the JSON string but got " + data['GiftCardSecurityCode']);
        }
        // ensure the json data is a string
        if (data['TransactionRef'] && !(typeof data['TransactionRef'] === 'string' || data['TransactionRef'] instanceof String)) {
            throw new Error("Expected the field `TransactionRef` to be a primitive type in the JSON string but got " + data['TransactionRef']);
        }

        return true;
    }


}

RedeemRequest.RequiredProperties = ["GiftCardNum", "GiftCardSecurityCode", "Amount", "OrderId", "TransactionRef"];

/**
 * MaxLength:25
 * @member {String} GiftCardNum
 */
RedeemRequest.prototype['GiftCardNum'] = undefined;

/**
 * MaxLength:3
 * @member {String} GiftCardSecurityCode
 */
RedeemRequest.prototype['GiftCardSecurityCode'] = undefined;

/**
 * @member {Number} Amount
 */
RedeemRequest.prototype['Amount'] = undefined;

/**
 * int64
 * @member {Number} OrderId
 */
RedeemRequest.prototype['OrderId'] = undefined;

/**
 * MaxLength:35
 * @member {String} TransactionRef
 */
RedeemRequest.prototype['TransactionRef'] = undefined;






export default RedeemRequest;

